import React from 'react';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { WorkplaceType } from '../../../Enums/WorkplaceType.enum';
import ManagerWorkplaceForm from '../ManagerWorkplaceForm/ManagerWorkplaceForm';
import {
	prepareWorkplaceDataByType,
	WorkplaceFolderValues,
	WorkplaceNormalValues,
} from '../../../Services/workplaceCreate.helper';
import apiClient from '../../../../../Services/ApiClient';
import useApiClient from '../../../../Base/Hooks/useApiClient';
import Loading from '../../../../../Components/Loading';

interface Props {
	type: WorkplaceType;
	formScheme: ItemScheme[];
	onSuccess: () => void;
	isLoading: boolean;
	setIsLoading: (isLoading: boolean) => void;
}

const ManagerWorkplaceCreate: React.FC<Props> = ({
	formScheme,
	type,
	onSuccess,
	isLoading,
	setIsLoading,
}) => {
	const { displayError, showUnexpectedError } = useApiClient();

	const handleCreate = async (
		values: WorkplaceFolderValues | WorkplaceNormalValues,
	) => {
		setIsLoading(true);
		//CALLING HELPER TO PREPARE DATA FO API
		const data = prepareWorkplaceDataByType({ type, values });
		try {
			const response = await apiClient.post(`/workplaces/`, data);
			if (response.status === 200) {
				onSuccess();
			} else {
				showUnexpectedError();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<ManagerWorkplaceForm
			formScheme={formScheme}
			onSubmit={handleCreate}
			submitButtonText='base.create'
		/>
	);
};

export default ManagerWorkplaceCreate;
